import React from 'react'
import { Route } from 'react-router-dom'
import { StandardLayout } from 'common/layouts/StandardLayout'
import { PairDevicePage } from '../PairDevicePage'

export const routes = (
  <Route path={['/iq/:shortcode', '/iq']}>
    <StandardLayout greyBg>
      <PairDevicePage />
    </StandardLayout>
  </Route>
)
